import router from '../router'
import moment from 'moment'

export const app = {
    mutations: {
        APP_STORAGE_SAVE() {},
        APP_STORAGE_LOAD() {},
        RESET_FROM_INITIAL_STATE(state, payload) {
            if(payload.args.object !== undefined) {
                this.$vue.set(this.state[payload.args.module], payload.args.object, payload.initialState[payload.args.module][payload.args.object])
            } else {
                this.$vue.set(this.state, payload.args.module, payload.initialState[payload.args.module])
            }
        }
    },
    actions: {
        async saveState({ commit, dispatch }, payload) {
            const userId = await dispatch('users/getUserId')
            const appData = await this.$storage.getItem(`df.appData.${userId}`)
            return this.$storage.setItem(`df.appData.${userId}`, {
                ...appData,
                ...payload,
                date: moment().format(),
                version: process.env.PACKAGE_VERSION
            }).then(() => {
                commit('APP_STORAGE_SAVE')
                return Promise.resolve()
            }).catch(error => {
                console.error(error)
                dispatch('resetState')
                return Promise.reject(new Error('Local storage "setItem" error'))
            })
        },
        async getState({ commit, dispatch }, payload) {
            const userId = await dispatch('users/getUserId')
            return this.$storage.getItem(`df.appData.${userId}`).then(response => {
                if(response === null || response.version === undefined || response.version !== process.env.PACKAGE_VERSION) {
                    if(response && response.version) {
                        console.log(`Storage old version: ${response.version}, app version: ${process.env.PACKAGE_VERSION}`)
                    }
                    dispatch('resetState').then(() => {
                        if(!router.currentRoute.meta.dontRedirectToCart) {
                            router.push({ name: 'start' }).catch(() => {})
                        }
                        return Promise.resolve(response)
                    })
                }
                commit('APP_STORAGE_LOAD')
                return Promise.resolve(response)
            }).catch(error => {
                console.error(error)
                return Promise.reject(new Error('Local storage "getItem" error'))
            })
        },
        async resetState({ dispatch }) {
            const userId = await dispatch('users/getUserId')
            const initialState = await this.$storage.getItem('initialState')
            if(initialState) {
                this.replaceState(initialState)
                if(userId) {
                    await this.$storage.removeItem(`df.appData.${userId}`)
                }
                return Promise.resolve()
            } else {
                return Promise.reject(new Error('InitalState read error'))
            }
        },
        fetchAppData({ dispatch }) {
            return new Promise((resolve, reject) => {
                dispatch('getState').then(response => {
                    // check if data is not too old
                    if(!response || !response.date || !moment().subtract(process.env.VUE_APP_LOCAL_STORAGE_HOURS_VALIDITY, 'hours').isBefore(response.date)) {
                        dispatch('resetState').then(() => {
                            if(!router.currentRoute.meta.dontRedirectToCart) {
                                router.push({ name: 'start' }).catch(() => {})
                            }
                        })
                    }
                    // case 1: no data in storage at all
                    if(typeof response === 'undefined' || response === null || typeof response.customer === 'undefined') {
                        // go to step 1
                        if(!router.currentRoute.meta.dontRedirectToCart) {
                            router.push({ name: 'start' }).catch(() => {})
                        }
                        resolve()
                    } else {
                        // save customer data from storage to vuex
                        dispatch('setCustomer', response.customer)
                        if(response.weekCart !== undefined) {
                            dispatch('setWeekCart', response.weekCart)
                        }
                        // dispatch('setCustomer', response.customer)
                        // case 2: customer has already checked availible days for his addresses
                        if(response.customer.addresses.some(address => address.supportedDays.some(item => item.is_active === true))) {
                            if(!router.currentRoute.meta.dontRedirectToCart) {
                                router.push({ name: 'cart' }).catch(() => {})
                            }
                            resolve()
                        } else {
                            // go to step 2
                            if(!router.currentRoute.meta.dontRedirectToCart) {
                                router.push({ name: 'delivery-address' }).catch(() => {})
                            }
                            resolve()
                        }
                    }
                }).catch(error => {
                    console.error(error)
                    reject(new Error('Local storage error'))
                })
            })
        },
        resetFromInitialState({ commit }, args) {
            return this.$storage.getItem('initialState').then(initialState => {
                commit('RESET_FROM_INITIAL_STATE', {
                    args,
                    initialState
                })
            })
        }
    }
}
